import moment from 'moment';
import Base from 'app/models/base';

export default Base.extend({
  parse(attributes) {
    const attrs = { ...attributes };
    attrs.facilities = attrs.facilities.map(fac => ({
      ...fac,
      daily_stats: fac.daily_stats.map(stat => ({
        ...stat,
        date: moment(stat.date).format('MM-DD'),
      })),
    }));
    return attrs;
  },
});



// WEBPACK FOOTER //
// ./app/models/tracking_analytic.js